// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blog-author[data-v-6c32032f]{margin-top:2rem}.blog-author--top[data-v-6c32032f]{padding-bottom:1.5rem;margin-top:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
